import { render, staticRenderFns } from "./EstimativaCustoPage.vue?vue&type=template&id=6ee8e2ca&"
import script from "./EstimativaCustoPage.vue?vue&type=script&lang=js&"
export * from "./EstimativaCustoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports